<template>
    <div>
        <div class="modal-backdrop show"></div>
        <div class="modal d-block" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('add_country') }}</h5>
                        <button type="button" class="close" @click="$emit('close')">
                        <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <label for="code"> Code </label>
                        <app-input
                            type="text"
                            class="form-control"
                            v-model="code"
                            placeholder="Country code"
                        />
                        <br>
                        <label for="name" class="required">Name</label>
                        <app-input
                            type="text"
                            class="form-control"
                            v-model="country"
                            placeholder="Country name"
                        />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="$emit('close')">
                            Close
                        </button>
                        &nbsp;
                        <button type="button" class="btn btn-primary" @click="submit">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "AddCountry",
    data() {
        return {
            country: "",
            code : "",
        };
    },
    methods: {
        submit() {
            this.$emit("save", this.country, this.code);
            this.country = "";
        },
    },
};
</script>
  